import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';

import { TextFieldElement } from 'components/muiInputWrappers';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  locationName?: string;
  comercialName?: string;
};

type Props = {
  form: UseFormReturn;
};

function LocationSearch({ form }: Props) {
  const { t } = useTranslation('global');
  return (
    <Box>
      <Typography>{t('common.commonProperties.ubicationName')}:</Typography>
      <TextFieldElement
        control={form?.control}
        name="locationName"
        placeholder={t('common.commonProperties.ubicationName')}
        size="small"
        style={{ width: '100%' }}
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
      <br />
      <Typography>{t('common.commonProperties.tradeName')}</Typography>
      <TextFieldElement
        control={form?.control}
        name="comercialName"
        placeholder={t('common.commonProperties.tradeName')}
        size="small"
        style={{ width: '100%' }}
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 300,
            message: t('ticket.messages.valueLongerThan300')
          }
        }}
        variant="outlined"
      />
    </Box>
  );
}

export default LocationSearch;
